<template>
  <div class="column-box">
    <slot name="header"></slot>
    <div
      v-for="(item, index) in list"
      :key="'column_content_' + index"
      :class="[{ alone: item.alone }, 'column_content_mrbtm']"
    >
    <template>
      <div class="column-title" v-if="!item.setColorBold">
        {{ item[paramsOpt.value] }}{{ separator }}
      </div>
      <div class="column-title" v-else :style="{color: item.setColorBold, fontWeight: 'bold'}">
        {{ item[paramsOpt.value] }}{{ separator }}
      </div>
    </template>
    <template v-if="item.tooTip">
      <el-popover
        placement="top-start"
        trigger="hover"
        :content="item.tooTip.content"
      >
        <span slot="reference">
          <i
            :class="[
              item.tooTip.iconClass ? item.tooTip.iconClass : 'el-icon-info',
            ]"
            class="tooTip"
          ></i>
        </span>
      </el-popover>
    </template>

    <template>
      <div class="column-cont" v-if="!item.bindHtml">
        <template v-if="!item.goPage && !item.downFile">
          <template v-if="item.finance">
            <span v-thousand-separator="getCont(item)"></span>元
          </template>
          <template v-else>
            {{ getCont(item) }}
          </template>
        </template>

        <template v-else-if="item.goPage">
          <template v-if="getCont(item) !== emptyText">
            <span @click="jumpPage(item)" class="comm-down-text-color jump-page">{{ getCont(item) }}</span>
          </template>
          <template v-else>
            <span>{{emptyText}}</span>
          </template>
        </template>

        <!-- 下载模块 -->
        <template v-else-if="item.downFile">
          <template v-if="getDownName(item)">
            <span @click="downFile(item)" class="comm-down-text-color">
              {{getDownName(item)}}
            </span>
          </template>
          <template v-else>{{emptyText}}</template>
        </template>

        <!-- 跳转页面模块 -->
        <template
          v-if="
            item.viewBtn &&
            (item.viewBtn.showFn === void 0 || item.viewBtn.showFn())
          "
        >
          <el-button
            :loading="item.viewBtn.loading"
            style="margin-left: 50px"
            :type="item.viewBtn.type ? item.viewBtn.type : 'primary'"
            @click="item.viewBtn.clickFn ? item.viewBtn.clickFn(item) : void 0"
            >{{ item.viewBtn.label ? item.viewBtn.label : "查看" }}</el-button
          >
        </template>

        <!-- Table列表模块 -->
        <template v-else-if="item.tableList" style="width: 300px">
          <div class="table-container">
            <el-table :data="item.tableList" border style="width: 500px">
                <el-table-column label="阶梯级数" type="index" width="80"></el-table-column>
                <el-table-column label="动态条件" prop="dynamicCondition"></el-table-column>
                <el-table-column label="结算金额" prop="settlementAmount"></el-table-column>
            </el-table>
          </div>
        </template>

        <slot :name="item.key"></slot>
      </div>
      <div class="column-cont" v-else v-html="item.bindHtml"></div>
    </template>

      <!-- 底部文字模块 -->
      <div class="column-cont-bottom-text" v-if="item.bottomText">
        <div class="title">{{ item[paramsOpt.value] }}{{ separator }}</div>
        <div class="text" v-html="item.bottomText"></div>
      </div>
    </div>
    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: 'ColumnBoxExpand',
  props: {
    column: {
      type: [String, Number],
      default: 3,
      validator(prop) {
        if (prop < 1) return false
        return prop % 1 === 0
      },
    },
    source: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => { },
    },
    list: {
      type: Array,
      default: () => [],
    },
    labelWidth: {
      type: [Number, String],
      default: '',
    },
    separator: {
      type: String,
      default: '',
    },
    paramsOpt: {
      type: Object,
      default: () => ({
        key: 'key',
        value: 'name',
      }),
    },
  },
  data() {
    return {
      // specialType: ['goPage', 'download'],
      emptyText: '--',
    }
  },
  methods: {
    getCont(item) {
      if (item.tableList) {
        return ''
      }
      const keys = item && this.paramsOpt.key && item[this.paramsOpt.key] && item[this.paramsOpt.key].split('.')
      let value = this.source
      for (const key of keys) {
        value = value && value[key]
      }
      value = value === 0 ? '0' : value
      if (item && item.source && value) {
        if (!Array.isArray(item.source)) {
          const has = item.source[value]
          return has
        }
      }
      return value || this.emptyText
    },

    // 跳转页面
    jumpPage(item) {
      const { path } = item.goPage
      const { query } = item.goPage
      // 是否是新页面
      const _blank = item.goPage._blank !== false
      if (path) {
        if (_blank) {
          this.$router.resolve({
            path,
            query,
          })
          this.$router.push({
            path,
            query,
          })
          // 新增tab历史标签后，不需要新开页面了
          // window.open(routeUrl.href, item.goPage.name ? item.goPage.name : '')
        } else {
          this.$router.push({
            path,
            query,
          })
        }
      } else {
        this.$message.error('无效的路径')
      }
    },

    // 下载附件
    downFile(item) {
      const { url } = item.downFile
      const fileName = this.getDownName(item)

      if (!url || !fileName) {
        this.$message.error('错误的下载路径')
        return
      }
      const link = document.createElement('a')
      // 将链接地址字符内容转变成blob地址
      fetch(url).then((res) => res.blob()).then((blob) => {
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        document.body.appendChild(link)
        link.click()
      })
    },

    // 获取下载模块显示的名称
    getDownName(item) {
      let name = ''
      if (item.downFile.url) {
        name = item.downFile.name
        if (name.indexOf('.') === -1) {
          if (name) {
            const fileSuffix = item.downFile.url.slice(item.downFile.url.lastIndexOf('.'))
            const result = item.downFile.url.indexOf('?') ? fileSuffix.split('?')[0] : fileSuffix
            name = item.downFile.name + result
          } else {
            name = '点击下载'
          }
        }
      } else {
        name = ''
      }
      return name
    },
  },
  mounted() {
    this.$nextTick(() => {
      const box = this.$el
      const width = box.offsetWidth - 8
      box.childNodes.forEach((div) => {
        if ((div.nodeType === 1) && (div.className.indexOf('alone') === -1)) {
          div.style.width = `${width / this.column}px`
        }
      })
      box.querySelectorAll('.column-title').forEach((div) => {
        let w = 'max-content'
        if (this.labelWidth !== 'max-content') {
          w = String(this.labelWidth)
          w += (w.endsWith('px') ? '' : 'px')
        }
        div.style.width = w
      })
    })
  },
}
</script>

<style lang="scss" scoped>
.column-box {
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .jump-page {
    text-decoration:underline;
  }

  .table-container {
    width: 100%;
    margin-top: 10px;
  }

  & > * {
    display: flex;
    line-height: 20px;
    margin-bottom: 23px;
    word-break: break-all;
    flex-wrap: wrap;

    > .column-title {
      text-align: right;
      padding-right: 10px;
      color: #333333;
    }

    > .column-cont {
      display: flex;
      flex: 1;
      color: #666;
    }
  }

  & > *.alone {
    width: 100% !important;
  }

  & > .area-box {
    margin-bottom: 0;
  }

  .column-cont-bottom-text {
    display: flex;
    width: 100%;
    .title {
      padding-right: 10px;
      opacity: 0;
    }
    .text {
      font-size: 12px;
    }
  }
}
.tooTip {
  margin-right: 8px;
  margin-left: -8px;
}
</style>
